import Vue from 'vue'

/**
 * Returns exercise state string
 * @name Exercise state str
 * @returns {string} Exercise state string
 */

const exerciseState = (exercise) => {
  // Maintaining retro compatibility. Add here older prop values
  const repetitions = {
    ok:
      exercise.reps_ok ||
      exercise.movementsExecuted ||
      exercise.correctedMovements,
    prescribed:
      exercise.reps_prescribed ||
      exercise.movementsPrescribed ||
      exercise.prescribedMovements,
  }

  const trainingTime = exercise.trainingTime || exercise.trainingtime || 0

  if (!repetitions.ok && !trainingTime) {
    return 'undone'
  }

  return repetitions.ok === repetitions.prescribed ? 'complete' : 'incomplete'
}

Vue.filter('exerciseState', exerciseState)

export default exerciseState
